import PointAndClickScene from "@/models/PointAndClickScene";
import PointAndClickItem from "@/models/PointAndClickItem";
import { Blink } from "@/assets/data/animations/animations";
import {
    AlarmSystem,
    Chair,
    HospitalBed,
    HospitalTV,
    Laptop,
    LukasBackpack
} from "@/assets/data/items/collection_items-ZORO-002";

const bgPosDeltaX = 180;
const bgPosDeltaY = 180;

export const Zoro002FollowupFirstTalkRecipientScene = new PointAndClickScene({

    id: 'zoro-002-intro-first_talk_recipient',
    startLocation: 'hospitalroom',
    showPhoneButton: true,
    locations: {
        'hospitalroom': {
            items: [
                new PointAndClickItem({
                    id: 'bg',
                    img: require('@/assets/images/scenes/zoro002/bg_hospitalroom.png'),
                    pos: { left: -bgPosDeltaX, top: -bgPosDeltaY },
                    layer: 1,
                }),
                new PointAndClickItem({
                    id: HospitalBed.id,
                    img: HospitalBed.img,
                    pos: { left: 979 - bgPosDeltaX, top: 623 - bgPosDeltaY },
                    layer: 1,
                }),
                new PointAndClickItem({
                    id: 'roomcart',
                    img: require('@/assets/images/scenes/zoro002/objects/_general/roomcart.png'),
                    pos: { left: 742 - bgPosDeltaX, top: 827 - bgPosDeltaY },
                    layer: 1
                }),
                new PointAndClickItem({
                    id: AlarmSystem.id,
                    img: AlarmSystem.img,
                    pos: { left: 977 - bgPosDeltaX, top: 718 - bgPosDeltaY },
                    layer: 2,
                }),
                new PointAndClickItem({
                    id: Chair.id,
                    img: Chair.img,
                    pos: { left: 86 - bgPosDeltaX, top: 942 - bgPosDeltaY },
                    layer: 2,
                }),
                new PointAndClickItem({
                    id: 'flowers',
                    img: require('@/assets/images/scenes/zoro002/objects/_general/flowers.png'),
                    pos: { left: 865 - bgPosDeltaX, top: 708 - bgPosDeltaY },
                    layer: 1
                }),
                new PointAndClickItem({
                    id: Laptop.id,
                    img: Laptop.img,
                    pos: { left: 752 - bgPosDeltaX, top: 750 - bgPosDeltaY },
                    layer: 2,
                }),
                new PointAndClickItem({
                    id: LukasBackpack.id,
                    img: LukasBackpack.img,
                    pos: { left: 829 - bgPosDeltaX, top: 1004 - bgPosDeltaY },
                    layer: 2,
                }),
                new PointAndClickItem({
                    id: HospitalTV.id,
                    img: HospitalTV.img,
                    pos: { left: 1812 - bgPosDeltaX, top: 223 - bgPosDeltaY },
                    layer: 1
                }),
                new PointAndClickItem({
                    id: 'recipient',
                    img: require('@/assets/images/characters/zorgontvanger_c2/zorgontvanger_c2_full_body.png'),
                    imgElements: [
                        {
                            id: 'eyes',
                            pos: { left: 114, top: 86 },
                            layer: 2,
                            img: require('@/assets/images/characters/zorgontvanger_c2/zorgontvanger_c2_full_eo.png'),
                            frames: [
                                {
                                    id: 'open',
                                    img: require('@/assets/images/characters/zorgontvanger_c2/zorgontvanger_c2_full_eo.png')
                                },
                                {
                                    id: 'closed',
                                    img: require('@/assets/images/characters/zorgontvanger_c2/zorgontvanger_c2_full_ec.png')
                                }
                            ],
                            timing: Blink.timing
                        },
                        {
                            id: 'mouth',
                            pos: { left: 125, top: 116 },
                            layer: 2,
                            img: require('@/assets/images/characters/zorgontvanger_c2/zorgontvanger_c2_full_mc.png')
                        }
                    ],
                    pos: { left: 516 - bgPosDeltaX, top: 590 - bgPosDeltaY },
                    scale: { x: -1, y: 1 },
                    layer: 5,
                    interactable: true,
                    itemType: "action",
                    hoverType: "talk",
                    action: "talk_with_recipient",
                    name: "Praat met Lukas"
                })
            ]
        },
    },
});